module.exports = __webpack_public_path__ + "static/soc1-24f2838a182f303c63fdb23e5afcfd6b.png";